var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"event-name",class:{ 'event-name--warning': _vm.event === 'change_wallet_key' }},[_c('div',{staticClass:"event-name__icon"},[_c(_vm.getIcon,{tag:"component"})],1),_vm._v("\n    "+_vm._s(_vm.$t(`events.${_vm.event}`))+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }